import FormStateActions from './constants';
import { IStepValues, IActionObject } from './types';

// action creators

// Sets form state for an array of fieldKey, fieldValue
export function setFormState(data: IStepValues): IActionObject {
  return { type: FormStateActions.SET_FORM_STATE, data };
}

// Clears form state
export function resetFormState(): IActionObject {
  return { type: FormStateActions.RESET_FORM_STATE };
}
try {
    // @ts-ignore
    setFormState.displayName = "setFormState";
    // @ts-ignore
    setFormState.__docgenInfo = { "description": "", "displayName": "setFormState", "props": { "fieldValues": { "defaultValue": null, "description": "", "name": "fieldValues", "required": true, "type": { "name": "IFieldValue[]" } } } };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/store/formState/actions.tsx#setFormState"] = { docgenInfo: setFormState.__docgenInfo, name: "setFormState", path: "src/store/formState/actions.tsx#setFormState" };
}
catch (__react_docgen_typescript_loader_error) { }